<template lang="html">
  <v-app>
    <div class="main large-screen__body">
      <v-toolbar dark tabs>
        <!-- left icons -->
        <v-btn icon>
          <img src="~icons/filter/filterIcon.png" alt="Filter">
        </v-btn>
        <v-btn icon>
          <img src="~icons/search/searchIcon.png" alt="Search">
        </v-btn>
        <v-spacer></v-spacer>

        <!-- center text -->
        <v-toolbar-title class="white--text">
          Effort
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon>
            <img class="img-detailed" src="~icons/shortActive/shortActiveIcon.png" alt="detailed">
        </v-btn>
        <v-btn icon>
            <img src="~icons/detailed/detailedIcon.png" alt="detailed">
        </v-btn>

        <v-tabs grow centered slot="extension" class="primary-tabs">
          <v-tab>
            Browse
          </v-tab>
          <v-tab>
            Mine
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <!-- list items -->
      <v-content class="body">
        <v-list>
          <v-list-item>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card>
                  <v-subheader class="grey--text">FT_213 till 31 November,2017</v-subheader>
                  <v-card-title primary-title>
                    Create prototypes for the app only in Ra hospital
                  </v-card-title>
                  <v-card-media>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs1 v-for="i in 6" :key="i">
                          <img class="image" v-bind:src="`https://randomuser.me/api/portraits/men/${i + 20}.jpg`" alt="lorem" width="100%" height="100%">
                        </v-flex>
                      </v-layout>
                    </v-container>
                   </v-card-media>
                  <ul class="below">
                    <li>Management</li>
                    <li>Engineering</li>
                    <li>Dentist</li>
                  </ul>
                </v-card>
              </v-flex>
            </v-layout>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card>
                  <v-subheader class="grey--text">FT_213 till 31 November,2017</v-subheader>
                  <v-card-title primary-title>
                    Create prototypes for the app only in Ra hospital
                  </v-card-title>
                  <v-card-media>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs1 v-for="i in 6" :key="i">
                          <img class="image" v-bind:src="`https://randomuser.me/api/portraits/men/${i + 20}.jpg`" alt="lorem" width="100%" height="100%">
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-media>
                  <ul class="below">
                    <li>Management</li>
                    <li>Engineering</li>
                    <li>Dentist</li>
                  </ul>
                </v-card>
              </v-flex>
            </v-layout>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card>
                  <v-subheader class="grey--text">FT_213 till 31 November,2017</v-subheader>
                  <v-card-title primary-title>
                    Create prototypes for the app only in Ra hospital
                  </v-card-title>
                  <v-card-media>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs1 v-for="i in 6" :key="i">
                          <img class="image" v-bind:src="`https://randomuser.me/api/portraits/men/${i + 20}.jpg`" alt="lorem" width="100%" height="100%">
                        </v-flex>
                      </v-layout>
                    </v-container>
                   </v-card-media>
                  <ul class="below">
                    <li>Management</li>
                    <li>Engineering</li>
                    <li>Dentist</li>
                  </ul>
                </v-card>
              </v-flex>
            </v-layout>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card>
                  <v-subheader class="grey--text">FT_213 till 31 November,2017</v-subheader>
                  <v-card-title primary-title>
                    Create prototypes for the app only in Ra hospital
                  </v-card-title>
                  <v-card-media>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs1 v-for="i in 6" :key="i">
                          <img class="image" v-bind:src="`https://randomuser.me/api/portraits/men/${i + 20}.jpg`" alt="lorem" width="100%" height="100%">
                        </v-flex>
                      </v-layout>
                    </v-container>
                   </v-card-media>
                  <ul class="below">
                    <li>Management</li>
                    <li>Engineering</li>
                    <li>Dentist</li>
                  </ul>
                </v-card>
              </v-flex>
            </v-layout>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>
      </v-content>

      <!-- bottom navigation -->
      <v-bottom-nav grow fixed value="show" :active.sync="e1">

        <v-btn flat value="clip" >
          <img src="~icons/activeTasks/tasksActive.png" alt="activeTasks">
        </v-btn>
        <v-btn flat value="message">
          <img src="~icons/messages/messages.png" alt="messages">
        </v-btn>
        <v-btn flat value="notify">
          <img src="~icons/notification/notification.png" alt="notification">
        </v-btn>
        <v-btn flat value="profile">
          <img src="~icons/profile/profile.png" alt="profile">
        </v-btn>
      </v-bottom-nav>
    </div>
  </v-app>
</template>


<script>
export default {
  data() {
    return {
      e1: '',
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {
    .bottom-nav--active{
      color: $blue;
    }

    .list__tile__content {
      color: $blue;
      font-size: 16px;
    }

    .divider {
      color: rgb(229,229,229);
    }

    .body {
      padding-bottom:80px;
    }

    .card {
      padding-top: 20px;
      padding-left:28px;
      min-height: 170px;
      box-shadow:none;
    }

    .card__title {
      padding:4px;
      color: $blue;
      font-size: 16px;
    }

    .below {
      font-size:13px;
      color: rgb(178,186,194);
      margin:0;
      padding:0;
      padding-top: 3px;
      padding-bottom: 7px;
    }

    li {
      display: inline;
      padding:3px;
      list-style-type: disc !important;
    }

    .main {
      height:100%;
      weight:100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue